// Path: ./src/app/components/TextField/index.tsx
import styled from "styled-components";

export const InputField = styled.input`
  width: 100%;
  max-width: 380px;
  padding: 12px;
  border: 1px solid #fecc9f;
  outline-color: #fecc9f;
  border-radius: 6px;
  font-size: 18px;
  caret-color: #fd954f;
`;
